import { toast } from "react-toastify";
import { getSimplifiedError } from "utils/error";

export const Error = (message) => toast.error(getSimplifiedError(message).toString());
export const Success = (message) => toast.success(message);
export const Info = (message) => toast.info(message);
